export let loadingCount = 0;
export let loadingHandler: any;

export const ItiLoadingService = {
	setLoadingHandler(setLoading: (loading: boolean) => void) {
		loadingHandler = setLoading;
	},
	enableLoading() {
		if (!this.isLoading()) {
			loadingHandler(true);
		}
		loadingCount++;
	},
	disableLoading() {
		loadingCount--;
		if (!this.isLoading()) {
			loadingHandler(false);
		}
	},
	isLoading(): boolean {
		return loadingCount > 0;
	},
};
